/*
 * @Description: 优惠券
 * @Author: ywj
 * @Date: 2025-03-20 16:01:44
 * @LastEditTime: 2025-04-23 10:38:25
 * @LastEditors: ywj@originqc.com
 */
import React from "react";
import './index.scss';
import effectBg from '../imgs/effect.png'
import ineffectBg from '../imgs/ineffect.png'
import effectTop from '../imgs/effect_top.png'
import ineffectTop from '../imgs/ineffect_top.png'
import { Checkbox,Radio } from 'antd';
interface IProps{ 
  // type:'noUse'|'waitUse'
  id: number,
  cardId: number|undefined,
  setCardId: (id: number) => void,
  validTime: string,
  amount:string
  // addressId: number,
  // onClick: () => void,
  // key: number,
  // ...item

}

const stateObj = {
  'noUse': '立即使用',
  'waitUse': '待使用',  
}
const Card: React.FC<IProps> = (props) => {
  const { id ,setCardId,cardId,validTime,amount} = props;

 console.log(cardId,id,cardId===id,'id')
  const onCheck = (e: any) => {
    console.log(e.target.value,'eeeeee')
    // 当选中时，清除之前的选中状态，只保留当前选中的值
    if (e.target.value === cardId) {
      setCardId(0)
    } else { 
      setCardId(e.target.value)
    }
    
    // if (checkedList.size > 0) {
    //   setCheckedList(new Set([e.target.value]));
    // } else {
    //   setCheckedList(new Set(checkedList).add(e.target.value));
    // }
    
  };

  const handleCheck = () => {
    if (id === cardId) {
      setCardId(0)
    } else { 
      setCardId(id)
    }
}
  return <div
    className={`order-coupon-card ${cardId === id ? 'noUse' : ''}`}
    onClick={handleCheck}
    // style={{ background: `url(${type !== 'ineffect' ? effectBg : ineffectBg}) no-repeat` }}
  >
    {/* <div className={`top top-${type}`} */}
    <div className={`top top-${cardId===id?'noUse':''}`}
      // style={{ background: `url(${type === 'noUse' ? effectTop : ineffectTop}) no-repeat` }}
    >
      <span className="top-text">会员专享优惠券</span>
    </div>
    <p className="money">￥ <span className='num'>{amount}</span></p>
    <div className="radio-box">
      <Checkbox
        value={ id}
        checked={cardId===id}
        // onChange={onCheck}
      ></Checkbox >
    
    </div>
   {/* {type==='noUse'?<p className="btn">立即使用</p>:
     <>
      <p className="state">
      <span className="state-text">{stateObj[type]}</span>
    </p></>} */}
    <div className={`content-btm ${cardId===id?'noUse':''}`}>
      <p>有效期至：{ validTime}  </p>
      <p> 仅限部分活动商品使用，不可叠加</p>
    </div>
  </div>;
}

export default Card;
